import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerFetchBillDetailsApiCallSuccess } from 'redux/actions';
import { TRIGGER_FETCH_BILL_DETAILS_API } from 'redux/actionTypes';
import { apiCall } from 'services';

function* triggerFetchBillDetailsApiCall(actions) {
	const { callback, stopLoader, data = '' } = actions;
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE,
		url: `${API_CONSTANT.URL.BILL_DETAILS}${data ? API_CONSTANT.QUERY_PARAMS.BILL_ID + data : ''}`,
		method: 'GET',
		options: {
			defaultLoader: !stopLoader,
		},
		loaderDetails: {
			first_message: 'fetching your',
			start_index: 0,
			range: 8,
			second_message: 'bill details',
		},
	});
	if (api && api.data.data) {
		const apiData = api.data.data;
		callback && callback(apiData);
		yield put(triggerFetchBillDetailsApiCallSuccess(apiData));
	}
}

export default function* triggerFetchBillDetailsApiCallSaga() {
	yield takeEvery(TRIGGER_FETCH_BILL_DETAILS_API, triggerFetchBillDetailsApiCall);
}
